import { Box, Card, CardContent } from '@mui/material';
import LocationCityRoundedIcon from '@mui/icons-material/LocationCityRounded';
import { Station } from '../utils/types';

type StationCardProps = {
    station: Station;
    index: number;
    handleOnClick: (stationClicked: Station) => void;
};

function StationCard(props: StationCardProps) {
    const { station, index, handleOnClick } = props;
    return (
        <Card
            sx={{
                width: {
                    xs: '100%',
                    sm: '100%',
                    md: '600px',
                    lg: '600px',
                },
                marginTop: '1rem',
                maxWidth: '600px',
                maxHeight: '75px',
                cursor: 'pointer',
            }}
            variant='outlined'
            key={index}
            onClick={() => handleOnClick(station)}>
            <CardContent
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    textAlign: 'center',
                    padding: '1rem !important',
                }}>
                <Box>{station.name}</Box>
                <LocationCityRoundedIcon fontSize='medium' />
            </CardContent>
        </Card>
    );
}

export default StationCard;
